import { getProjectName } from 'lib/get-project-name'
import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'

export type ArrowProps = {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
  isActive: boolean
  position?: string
}

export const NextArrow: FC<ArrowProps> = ({ isActive = true, onClick, position = '2.4rem' }) => {
  return (
    <ArrowNext isActive={isActive} onClick={onClick} position={position}>
      <Icon name="arrow-right" size={0.8} />
    </ArrowNext>
  )
}

export const PrevArrow: FC<ArrowProps> = ({ isActive = true, onClick, position = '2.4rem' }) => {
  return (
    <ArrowPrev isActive={isActive} onClick={onClick} position={position}>
      <Icon name="arrow-left" size={0.8} />
    </ArrowPrev>
  )
}

export const Arrow = styled.div<{ isActive: boolean }>`
  position: absolute;
  top: 50%;
  top: ${({ theme }) => (getProjectName() === 'generic_v2' ? '25%' : '50%')};
  color: white;
  cursor: pointer;
  width: ${({ theme }) => theme.spacing[8]};
  height: ${({ theme }) => theme.spacing[8]};
  border-radius: 50%;
  opacity: ${({ isActive }) => (isActive ? '1' : '0.5')};
  background: rgb(77, 77, 77);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  &:hover {
    opacity: ${({ isActive }) => (isActive ? '0.8' : '0.4')};
  }
`

const ArrowPrev = styled(Arrow)<{ position: string }>`
  ${({ position, theme }) =>
    createMediaStyles(() => ({
      phone: 'left: 0',
      tablet: `left: ${theme.spacing[11]}`,
      desktop: `left: ${position}`
    }))}
`

const ArrowNext = styled(Arrow)<{ position: string }>`
  ${({ position, theme }) =>
    createMediaStyles(() => ({
      phone: 'right: 0',
      tablet: `right: ${theme.spacing[11]}`,
      desktop: `right: ${position}`
    }))}
`
